import React from 'react';

export type UserDetailTabKey = 'overview' | 'orders' | 'loyalty' | 'activity';

export interface UserDetailTabItem {
  key: UserDetailTabKey;
  label: string;
  children: React.ReactNode;
}

interface UserDetailTabsProps {
  activeKey: UserDetailTabKey;
  onChange: (key: UserDetailTabKey) => void;
  items: UserDetailTabItem[];
}

export const UserDetailTabs: React.FC<UserDetailTabsProps> = ({
  activeKey,
  onChange,
  items,
}) => {
  const activeItem = items.find(t => t.key === activeKey);

  return (
    <div className="merchant-detail-tabs">
      <div className="merchant-detail-tabs-list" role="tablist">
        {items.map(item => (
          <button
            key={item.key}
            type="button"
            role="tab"
            aria-selected={activeKey === item.key}
            className={`merchant-detail-tab ${
              activeKey === item.key ? 'merchant-detail-tab-active' : ''
            }`}
            onClick={() => onChange(item.key)}
          >
            <span className="merchant-detail-tab-label">{item.label}</span>
          </button>
        ))}
      </div>
      <div className="merchant-detail-tabs-panel" role="tabpanel">
        {activeItem?.children}
      </div>
    </div>
  );
};
